import { SVGAttributes } from "react";

type SparklesSearchProps = SVGAttributes<SVGElement> & {
  size?: number | string;
};

export function SparklesSearch({
  size = 24,
  className,
  ...props
}: SparklesSearchProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.00003 24.0002L7.34003 19.6602M5 14C5 18.4183 8.58172 22 13 22C17.4183 22 21 18.4183 21 14C21 9.58172 17.4183 6 13 6C8.58172 6 5 9.58172 5 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#sparkles-search-clip)">
        <path
          d="M8.67621 2.91946C8.71212 2.72721 8.81413 2.55358 8.96458 2.42864C9.11503 2.30369 9.30443 2.23529 9.5 2.23529C9.69557 2.23529 9.88498 2.30369 10.0354 2.42864C10.1859 2.55358 10.2879 2.72721 10.3238 2.91946L11.2046 7.57725C11.2671 7.9084 11.428 8.213 11.6663 8.4513C11.9046 8.6896 12.2092 8.85053 12.5404 8.91308L17.1982 9.79386C17.3904 9.82976 17.5641 9.93177 17.689 10.0822C17.814 10.2327 17.8824 10.4221 17.8824 10.6176C17.8824 10.8132 17.814 11.0026 17.689 11.1531C17.5641 11.3035 17.3904 11.4055 17.1982 11.4414L12.5404 12.3222C12.2092 12.3848 11.9046 12.5457 11.6663 12.784C11.428 13.0223 11.2671 13.3269 11.2046 13.658L10.3238 18.3158C10.2879 18.5081 10.1859 18.6817 10.0354 18.8067C9.88498 18.9316 9.69557 19 9.5 19C9.30443 19 9.11503 18.9316 8.96458 18.8067C8.81413 18.6817 8.71212 18.5081 8.67621 18.3158L7.79544 13.658C7.73288 13.3269 7.57195 13.0223 7.33366 12.784C7.09536 12.5457 6.79076 12.3848 6.45961 12.3222L1.80181 11.4414C1.60957 11.4055 1.43594 11.3035 1.31099 11.1531C1.18604 11.0026 1.11765 10.8132 1.11765 10.6176C1.11765 10.4221 1.18604 10.2327 1.31099 10.0822C1.43594 9.93177 1.60957 9.82976 1.80181 9.79386L6.45961 8.91308C6.79076 8.85053 7.09536 8.6896 7.33366 8.4513C7.57195 8.213 7.73288 7.9084 7.79544 7.57725L8.67621 2.91946Z"
          fill="currentColor"
          stroke="#232F3D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="sparkles-search-clip">
          <rect width="19" height="19" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
